<template>
    <div class="container-row bg-primary">
        <query-panel style="width: 40%;" />
        <overlay-panel style="width: 20%;" />
        <my-location-panel style="width: 40%;" />
    </div>
</template>

<script>
import MyLocationPanel from '../Toolboxes/MyLocationPanel'
import OverlayPanel from '../Toolboxes/OverlayPanel'
import QueryPanel from '../Toolboxes/QueryPanel'

export default {
  name: 'HeaderContainer',
  components: {
    MyLocationPanel,
    OverlayPanel,
    QueryPanel
  }
}
</script>

<style scoped>
.container-row {
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Containers/HeaderContainer.vue